import React, { useState, useEffect } from "react";
import FullScreenModal from "@/features/shell/components/FullScreenModal/FullScreenModal";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { SignInForm } from "./SignInForm";
import { lastSession } from "utilities/lastSession";
import { useIsMobile } from "@/hooks/useDisplay";
import * as styles from "./Auth.module.scss";

type SignInModalProps = {
  onComplete?: () => void;
};

const SignInModal = ({ onComplete }: SignInModalProps) => {
  const isMobile = useIsMobile();
  const isOpen = useShellStore((state) => state.modal === "signIn");
  const setModal = useShellStore((state) => state.setModal);
  const [ignoreLastSession, setIgnoreLastSession] = useState(false);
  const existingSession = ignoreLastSession ? null : lastSession.get();

  useEffect(() => {
    if (!isOpen) {
      setIgnoreLastSession(false);
    }
  }, [isOpen]);

  return (
    <FullScreenModal
      isOpen={isOpen}
      onClose={() => setModal(null)}
      title={!isMobile && existingSession ? undefined : "Log In"}
      contentClassName={styles.centered}
      moveTitleOnMobile
      hideSeparator
    >
      <SignInForm
        onIgnoreLastSession={() => setIgnoreLastSession(!ignoreLastSession)}
        lastSession={existingSession ?? undefined}
        onComplete={onComplete}
      />
    </FullScreenModal>
  );
};

export { SignInModal };
